import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import Tutorial01 from '../../img/tutorial/01.png';
import Tutorial02 from '../../img/tutorial/02.png';
import Tutorial03 from '../../img/tutorial/03.png';
import Tutorial04 from '../../img/tutorial/04.png';
import './Tutorial.css'

export default function TutorialHome(props) {
  const [ intro, setintro ] = useState(true);
  const [ divclass, setdivclass ] = useState("tutorialdiv");
  const [ mainclass, setmainclass ] = useState("tutorialmain tutorialmain0");
  const [ idx, setidx ] = useState(0);
  const final = 3;

  const skip = () => {
    setdivclass("tutorialdiv tutorialdivhidden");
  }
  const next = () => {
    const i = idx + 1;
    setmainclass("tutorialmain tutorialmain"+i);
    setidx(i);
  }
  const back = () => {
    const i = idx - 1;
    setmainclass("tutorialmain tutorialmain"+i);
    setidx(i);
  }
  return (
    <div className={divclass}>
      <div className={"tutorialinner"}>
        <div className={mainclass}>
          <h2 className={"tutorialtitle"}>SelectBookの使い方({idx+1}/4)</h2>
        </div>
        {idx === 0? <img src={Tutorial01} style={{width: "100%", height: "75%", objectFit: "contain"}} />: null}
        {idx === 1? <img src={Tutorial02} style={{width: "100%", height: "75%", objectFit: "contain"}} />: null}
        {idx === 2? <img src={Tutorial03} style={{width: "100%", height: "75%", objectFit: "contain"}} />: null}
        {idx === 3? <img src={Tutorial04} style={{width: "100%", height: "75%", objectFit: "contain"}} />: null}
        <div className={"tutorialbutton"}>
          {idx > 0?
            <Button type="button" variant="contained" color="primary" onClick={back}>
              前へ
            </Button>
          : null }
          <Button type="button" variant="contained" color="secondary" onClick={skip}>
            {idx === final? <>終了</>: <>スキップ</> }
          </Button>
          {idx < final?
            <Button type="button" variant="contained" color="primary" onClick={next}>
              次へ
            </Button>
          : null }
        </div>
      </div>
    </div>
  )
}